export const DEFAULT_CHECKOUT_FAQ = [
    {
        h3: 'Pourquoi nos contrats sont-ils plus fiables que de simples modèles ?',
        p: 'Tous nos documents juridiques sont rédigés par des avocats expérimentés. Plus de 100 00 clients ont téléchargé nos contrats qui sont constamment mis à jour des dernières lois'
    },
    {
        h3: 'Après avoir effectué le paiement, puis-je modifier mon contrat ?',
        p: 'Oui ! Vous pouvez modifier à tout moment votre contrat en revenant sur le questionnaire à tout moment. Attention toutefois à respecter la loi en vigueur si vous décidez de modifier vous-même votre contrat..'
    },
    {
        h3: 'Et si j’ai un doute sur une disposition du contrat ?',
        p: 'En cas de doute, vous pouvez faire appel à un avocat expérimenté. Lors de cet appel, vous pourrez poser toutes vos questions relatives à votre contrat. Il pourra également vous conseiller et vous assister dans vos démarches juridiques. L’appel dure 20 minutes et est facturé 29,90€'
    }
]

export const CONTRACTS_WITHOUT_CHECKOUT_META_ID = [136]



// WEBPACK FOOTER //
// ./src/constants/default_checkout.js